import {Observable, of} from 'rxjs';

export class NavigationLink {
    constructor(
        public readonly text: string,
        public readonly url: Observable<string[]> | null,
        public readonly icon: string | null = null,
        public badgeText: Observable<string> = null,
        public children: Observable<NavigationLink[]> = of([]),
        public readonly disabled: Observable<boolean> = of(false),
        public readonly linkClassName: string = null,       
        public includeQueryParams?: boolean,
        public imgUrl?: string | null,
        public openNewTab?: boolean,
    ) {}
}